// export default `
//   query getStoresAndCurrencies {
//       availableStores {
//         store_code
//       }
//     currency {
//       available_currency_codes
//     }
//   }
// `;

export default `query Currency {
  currency {
    available_currency_codes {
      code
      symbol
      __typename
    }
    base_currency_code
    base_currency_symbol
    default_display_currency_code
    default_display_currency_symbol
    exchange_rates {
      currency_to
      rate
      __typename
    }
    __typename
  }
}`;
